import { Box } from '@material-ui/core';
import { NaturalPersonRisk } from '@nemuru-eng/js-api-client';
import React from 'react';

import { useCustomTheme } from '../../../../../../../../../../hooks/useCustomTheme';
import { ReadOnlyDataRow } from '../../../../../../../ReadOnlyDataRow';
import { Text } from '../../../../../../../Text';
import { MetricId } from '../constants/MetricId';
import { ScoringStatusTag } from './ScoringStatusTag';

interface NaturalPersonRiskScoringProps {
  naturalPersonRisk: NaturalPersonRisk[];
}

export default function NaturalPersonRiskScoring({ naturalPersonRisk }: NaturalPersonRiskScoringProps) {
  const { palette } = useCustomTheme();
  const sortedNaturalPersonRiskAssessments = naturalPersonRisk.sort(
    (a, b) => b.updatedAt.getTime() - a.updatedAt.getTime(),
  );
  const lastNaturalPersonRiskAssessments = sortedNaturalPersonRiskAssessments[0];
  const riskScoring = lastNaturalPersonRiskAssessments.rules?.find((rule) => rule.metricId === MetricId.RISK_SCORE);
  const unpaidOperations = lastNaturalPersonRiskAssessments.rules?.find(
    (rule) => rule.metricId === MetricId.NUMBER_OF_UNPAID_OPERATION,
  );

  const getIconByComplyingValue = (comply: boolean | undefined) => {
    switch (comply) {
      case true:
        return (
          <i
            className={'material-icons-outlined'}
            style={{ fontSize: '18px', verticalAlign: 'middle', color: palette.success.main }}
          >
            check
          </i>
        );
      case false:
        return (
          <i
            className={'material-icons-outlined'}
            style={{ fontSize: '18px', verticalAlign: 'middle', color: palette.error.main }}
          >
            close
          </i>
        );
    }
  };

  return (
    <>
      <ReadOnlyDataRow
        strongTitle
        labelIcon={'info'}
        tooltipTitle={<Text tId={'WHAT_IS_RECOMMENDATION'} />}
        labelTextId={'ASSESSMENT_RESULT'}
        value={<ScoringStatusTag comply={lastNaturalPersonRiskAssessments.comply} />}
      />
      <Box pt={1} />
      <ReadOnlyDataRow
        underlined
        forceSingleLine
        labelIcon={'info'}
        tooltipTitle={<Text tId={'WHAT_IS_SCORING'} />}
        labelTextId={'SCORING'}
        value={riskScoring?.metricCalculation?.externalMetricCalculations?.riskScore?.value}
        valueStartIcon={getIconByComplyingValue(riskScoring?.complying)}
      />
      <ReadOnlyDataRow
        underlined
        forceSingleLine
        labelTextId={'UNPAID_OPERATIONS'}
        value={unpaidOperations?.metricCalculation?.externalMetricCalculations?.numberOfUnpaidOperations?.value}
        valueStartIcon={getIconByComplyingValue(unpaidOperations?.complying)}
      />
    </>
  );
}
